import { dbs } from "@/firebase/firestore"
// import { Document, DocumentOptionsNoMAP } from "../shared/document"
import { Document, DocumentOptionsNoMAP, DocumentOptions } from "./shared/document"

import { fieryBindings, fieryMapMutations } from "fiery-vuex"

const firmsDB: any = dbs.firms

class Firm extends Document {
	name: String = ""
	logo: String | null = null
	active: Boolean = true
}

const FirmOptions = {
	include: ["name", "editableBy", "users", "managedBy", 'active'],
	extends: DocumentOptions,
	type: Firm
}

export default {
	namespaced: true,
	state: {
		current: null,
        firms: {},
        firms_a: []
	},
	mutations: {
		UPDATE_FIRM(state, userID) {
			return state.current.update(userID)
		},
		SET_FIRMS(state, getFirms) {
			let firms = getFirms()
            state.firms = firms
            state.firms_a = Object.values( firms )
		},
		...fieryMapMutations({
			SET_CURRENT_FIRM: "current"
			// 'SET_FIRMS': 'firms'
		})
	},
	getters: {},
	actions: {
		...fieryBindings(
			{
				fetchFirms( { state, rootState, dispatch, getters, rootGetters }, payload, $fiery ) {
					const options = {
						extends: FirmOptions,
                    }
					return $fiery(firmsDB, options, "SET_FIRMS")
				},
				fetchFirm({ state, dispatch, commit }, firmID, $fiery) {
					// If ID was passed, set to that specific doc (it's an edit), otherwise use for a new document to create
					const firmDoc = firmID
						? firmsDB.doc(firmID)
						: firmsDB.doc()
					return $fiery(firmDoc, FirmOptions, "SET_CURRENT_FIRM")
				}
			},
			{ commitInitial: false }
		),
		async save({ state, dispatch, commit, rootState, rootGetters }, payload) {
			return state.current.update(rootGetters.currentUserID)
		},
		async remove({ state, commit }, firmID) {
			return state.firms[firmID]
				? state.firms[firmID].remove()
				: false
		}
	}
}
